import { useEffect, useState } from "react";

/**
 * Returns `value` after it has stopped changing for `delay` ms.
 *
 * Used to keep a keystroke from becoming a server request. The caller still needs its
 * own stale-response guard: debouncing reduces the number of in-flight requests but
 * does not guarantee they resolve in order.
 */
export default function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
